export default "<p-messages class=\"message-container\" [closable]=\"false\" [(value)]=\"notifications\"></p-messages>\n"